// extracted by mini-css-extract-plugin
module.exports = {"container":"e_bv","submitted":"e_cv","slider":"e_dv","input":"e_ev","confirmButton":"e_fv","confirmIcon":"e_gv"};